import { useFormContext } from 'react-hook-form'

import { ContactFormDto } from '@/domains/contact/application/dto/createContact.dto'
import { Textarea } from '@/ui/components/ui/textarea'

export default function Message() {
  const {
    register,
    formState: { errors },
  } = useFormContext<ContactFormDto>()

  return (
    <div className="flex flex-col gap-1">
      <label htmlFor="message" className="field-label">
        Message*
      </label>
      <Textarea
        id="message"
        {...register('message', {
          required: 'Ajoutez un message à votre projet',
        })}
        placeholder="Message"
        required
        error={errors.message?.message as string}
      />
      <div className="min-h-5 font-mono text-[0.6875rem] text-signal">
        {errors.message?.message}
      </div>
    </div>
  )
}
